import React from 'react';
import {
  FormControl,
  FormLabel,
  GridItem,
  NumberInput,
  NumberInputField,
  Textarea,
  Text,
  Box,
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import { formatIndianCurrency } from '../../../utils/formatters';

const BudgetForm = ({ formData, handleChange }) => {
  console.log('BudgetForm Data:', formData.budget);
  console.log('Budget Amount Type:', typeof formData.budget?.amount);

  // Ensure budget object exists
  const budget = formData.budget || {};

  return (
    <>
      <GridItem>
        <FormControl>
          <FormLabel>Budget Amount</FormLabel>
          <NumberInput min={0} value={budget.amount || 0} onChange={(valueString) => {
            const value = Number(valueString);
            console.log('Budget Amount Changed:', value);
            handleChange('budget', { ...budget, amount: value });
          }}>
            <NumberInputField
              placeholder="Enter budget amount"
            />
          </NumberInput>
          {budget.amount > 0 && (
            <Text fontSize="sm" color="gray.600" mt={1}>
              {formatIndianCurrency(budget.amount)}
            </Text>
          )}
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl>
          <FormLabel>Currency</FormLabel>
          <ChakraSelect
            value={budget.currency || 'INR'}
            onChange={(e) => handleChange('budget', { ...budget, currency: e.target.value })}
          >
            <option value="INR">INR</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </ChakraSelect>
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl>
          <FormLabel>Budget Notes</FormLabel>
          <Textarea
            value={formData.budget?.notes || ''}
            onChange={(e) => handleChange('budget', { ...formData.budget, notes: e.target.value })}
            placeholder="Enter budget notes"
          />
        </FormControl>
      </GridItem>
    </>
  );
};

export default BudgetForm;
